import { AlpacaMark } from "@/components/AlpacaMark.tsx";

/** Isotipo + nombre de Alpaca POS (mismo que la PWA). */
export function Brand({ caption }: { caption?: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <AlpacaMark className="h-10 w-10 shrink-0" />
      <div className="min-w-0">
        <p className="truncate text-base leading-tight font-extrabold text-slate-900">
          Alpaca <span className="text-brand-600">POS</span>
        </p>
        {caption && <p className="truncate text-xs font-medium text-slate-500">{caption}</p>}
      </div>
    </div>
  );
}
